export default "__VITE_ASSET__BJdIqtnU__"